import { render, staticRenderFns } from "./LiquorBrewing.vue?vue&type=template&id=6b7e0120&scoped=true&"
import script from "./LiquorBrewing.vue?vue&type=script&lang=js&"
export * from "./LiquorBrewing.vue?vue&type=script&lang=js&"
import style0 from "./LiquorBrewing.vue?vue&type=style&index=0&id=6b7e0120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7e0120",
  null
  
)

export default component.exports